import { render, staticRenderFns } from "./SushiA3.vue?vue&type=template&id=bb897df8&scoped=true&"
import script from "./SushiA3.vue?vue&type=script&lang=js&"
export * from "./SushiA3.vue?vue&type=script&lang=js&"
import style0 from "./SushiA3.vue?vue&type=style&index=0&id=bb897df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb897df8",
  null
  
)

export default component.exports